module.exports = __webpack_public_path__ + "static/media/list-bulleted.dd5bdc34.svg";